<div
	fxLayout="row"
	fxLayout.xs="column"
	fxFlex="100%"
	class="primary-bg white-text"
	ngClass.gt-md="p-t-xxl"
	ngClass.lt-lg="p-t-l"
>
	<div
		fxLayout="column"
		fxFlex.gt-md="35%"
		ngClass.gt-md="p-l-xxl"
		ngClass.lt-lg="p-l-l"
		ngClass.lt-sm="p-l-m"
	>
		<div fxLayout="row" ngClass.gt-xs="p-t-l" ngClass.lt-sm="p-t-s p-b-s">
			<mat-card-title i18n="@@homepage_personal_banner_yourPlace">
				Your Place To Do Good
			</mat-card-title>
		</div>
		<div fxLayout="row" ngClass="w-100">
			<h1 i18n="@@homepage_personal_banner_individualOrganisation">
				Online fundraising for individuals and organisations
			</h1>
		</div>
		<div fxLayout="row" ngClass.gt-sm="p-t-xl" ngClass.lt-md="p-t-m">
			<app-start-fundraiser-button
				buttonType="homepage1"
			></app-start-fundraiser-button>
		</div>
		<div fxLayout="row" ngClass="p-t-s p-b-l">
			<div fxLayout="column" fxFlex="70%">
				<div fxLayout="row" ngClass="p-b-xxs">
					<b i18n="@@homepage_personal_banner_no_fees_to_start">
						No Fees To Start A Fundraiser
					</b>
				</div>
				<div fxLayout="column" class="homepage-smallest-font">
					<div i18n="@@homepage_personal_banner_standard_fees_info">
						Standard Payment Processing Fees
					</div>
					<div i18n="@@homepage_personal_banner_fees_per_donation">
						of €0,25 + 1.9% per donation apply
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		fxLayout="column"
		fxFlex="65%"
		fxLayoutAlign="end end"
		ngClass.gt-xs="p-t-xxl m-t-l"
	>
		<img
			class="w-100"
			[ngClass.sm]="'w-125-sm'"
			alt="WhyDonate Crowdfunding Platform"
			src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/HomePersonalBanner/public"
		/>
	</div>
</div>
